import { z } from "zod";

export const MISSION_PERIODS = ["DAILY", "WEEKLY", "ONE_TIME"] as const;
export const missionPeriodSchema = z.enum(MISSION_PERIODS);
export type MissionPeriod = z.infer<typeof missionPeriodSchema>;

export const achievementSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  iconKey: z.string(),
  xpReward: z.number().int(),
  category: z.string(),
  unlocked: z.boolean(),
  unlockedAt: z.string().nullable(),
});

export type AchievementDTO = z.infer<typeof achievementSchema>;

export const missionSchema = z.object({
  key: z.string(),
  name: z.string(),
  description: z.string(),
  goal: z.number().int(),
  rewardXp: z.number().int(),
  rewardCredits: z.number().int().nullable(),
  period: missionPeriodSchema,
  progress: z.number().int(),
  completed: z.boolean(),
});

export type MissionDTO = z.infer<typeof missionSchema>;

export const ACTIVITY_EVENT_TYPES = ["LEVEL_UP", "ACHIEVEMENT_UNLOCKED"] as const;
export const activityEventTypeSchema = z.enum(ACTIVITY_EVENT_TYPES);
export type ActivityEventType = z.infer<typeof activityEventTypeSchema>;

export const ACTIVITY_VISIBILITIES = ["PUBLIC", "FRIENDS", "PRIVATE"] as const;
export const activityVisibilitySchema = z.enum(ACTIVITY_VISIBILITIES);
export type ActivityVisibility = z.infer<typeof activityVisibilitySchema>;

/** Structured payload per event type — never a preformatted English string. */
export type LevelUpPayload = { fromLevel: number; toLevel: number };
export type AchievementUnlockedPayload = { achievementKey: string; achievementName: string };

export const activityEventSchema = z.object({
  id: z.string(),
  type: activityEventTypeSchema,
  payload: z.record(z.unknown()),
  actor: z.object({
    userId: z.string(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
  }),
  createdAt: z.string(),
});

export type ActivityEventDTO = z.infer<typeof activityEventSchema>;

export const ACTIVITY_FEED_MAX_LIMIT = 50;
export const ACTIVITY_FEED_DEFAULT_LIMIT = 20;

export const activityFeedResponseSchema = z.object({
  events: z.array(activityEventSchema),
  nextCursor: z.string().nullable(),
});

export type ActivityFeedResponse = z.infer<typeof activityFeedResponseSchema>;
